<ol class="breadcrumb">
  <li><a [routerLink]="['/home']">Home</a></li>
  <li><a [routerLink]="['/e-ergo']">E-Ergo</a></li>
  <li class="active">Dashboard</li>
</ol>
<div class="row">
  <div class="col-md-12">
    <div class="memic-panel panel">
      <div class="panel-heading">
        <h3 class="panel-title">
          E-Ergo Dashboard
        </h3>
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <input type="button" class="memic-btn btn btn-primary" value="Create" (click)="createNewForm()">
            </div>
          </div>
        </div>
        <div *ngIf="forms" class="row">
          <div class="col">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th scope="col">Employee Name</th>
                  <th scope="col">Type</th>
                  <th scope="col">Status</th>
                  <th scope="col">Date Submitted</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let form of forms; let i = index">
                  <td scope="row"><a style="cursor:pointer" href="javascript:void(null)" (click)="gotoForm(form.type, form.id)">{{form.employeeName}}</a></td>
                  <td scope="row">{{form.type}}</td>
                  <td scope="row">{{form.status}}</td>
                  <td scope="row">{{form.dateSubmitted | date:'shortDate'}}</td>
                </tr>
            </table>
          </div>
        </div>
        <div *ngIf="forms" class="row">
          <div class="col">
            <ul class="pagination">
              <li class="page-item" [ngClass]="{'disabled': !prevContinuationTokens.at(-1)}" (click)="prevPage()">
                <a class="page-link" href="javascript:void(null)">Previous</a>
              </li>
              <li class="page-item" [ngClass]="{'disabled': !nextContinuationToken}" (click)="nextPage()">
                <a class="page-link" href="javascript:void(null)">Next</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
